import React, { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
// import { Home, ShoppingCart, Grid, Phone, User,Sun, Clipboard, CreditCard,Clock  } from 'feather-icons-react';
import AdvancedMenuItems from "../Footer/AdvancedMenuItems";
import {
  IconBasket,
  IconCall,
  IconCategory,
  IconClipBoard,
  IconHome,
  IconUser,
  IconWallet,
  IconWeather,
  Iconboat,
  IconAboutUs,
  IconPolicy,
  IconPackage,
  IconUserCheck,
} from "../../../assets/icons";
import logoImg from "../../../assets/images/logo-s1.png";
import ContextApp from "./../../../core/contexts/context.app";

function AdvancedMenu({ showAdvancedMenu, setShowAdvancedMenu, isLogin }) {
  const handleClose = () => {
    setShowAdvancedMenu(false);
  };
  const ctx = useContext(ContextApp);

  return (
    <>
      <Offcanvas id="advancedMenu" show={showAdvancedMenu} onHide={handleClose}>
        <Offcanvas.Header closeButton className="pt-2 pb-0">
          <Offcanvas.Title>
            <img
              src={logoImg}
              className="img-fluid "
              style={{ maxHeight: "35px" }}
              alt="logo"
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-0">
          <AdvancedMenuItems
            advancedMenuTitle="صفحه اصلی"
            handleClose={handleClose}
            path="/"
            advancedMenuLogo={<IconHome fillColor="#000" />}
          />
          {!isLogin && (
            <AdvancedMenuItems
              advancedMenuTitle="ورود یا ثبت نام"
              handleClose={handleClose}
              path="/login"
              advancedMenuLogo={<IconUser fillColor="#000" />}
            />
          )}
          {isLogin && (
            <>
              <div className="bg-light py-2 px-3 opacity-75 border-top border-bottom my-2">
                حساب کاربری
              </div>
              <AdvancedMenuItems
                handleClose={handleClose}
                path="/order"
                advancedMenuLogo={<IconClipBoard fillColor="#000" />}
                advancedMenuTitle="سفارش ها"
              />
              <AdvancedMenuItems
                handleClose={handleClose}
                path="/wallet"
                advancedMenuLogo={<IconWallet fillColor="#000" />}
                advancedMenuTitle=" کیف پول"
              />
              <AdvancedMenuItems
                handleClose={handleClose}
                path="/profile"
                advancedMenuLogo={<IconUserCheck fillColor="#000" />}
                advancedMenuTitle="پروفایل"
              />
            </>
          )}
          <div className="bg-light py-2 px-3 opacity-75 border-top border-bottom my-2">
            دسترسی سریع
          </div>
          <AdvancedMenuItems
            advancedMenuTitle="لیست تفریحات"
            handleClose={handleClose}
            path={
              ctx.selectedCity?.englishName == undefined
                ? "/c"
                : `/c/${ctx.selectedCity?.englishName}`
            }
            advancedMenuLogo={<IconCategory fillColor="#000" />}
          />
          {/* <AdvancedMenuItems
            advancedMenuTitle="لیست پکیج ها"
            handleClose={handleClose}
            path="/g"
            advancedMenuLogo={<IconPackage fillColor="#000" />}
          /> */}
          <AdvancedMenuItems
            advancedMenuTitle="سبد خرید"
            handleClose={handleClose}
            path="/basket"
            advancedMenuLogo={<IconBasket fillColor="#000" />}
          />

          <AdvancedMenuItems
            advancedMenuTitle="تماس باما"
            handleClose={handleClose}
            path="/contact"
            advancedMenuLogo={<IconCall fillColor="#000" />}
          />
          <div className="bg-light py-2 px-3 opacity-75 border-top border-bottom mb-2 my-2">
            لینک های کاربردی
          </div>
          <AdvancedMenuItems
            advancedMenuTitle="درباره ما"
            handleClose={handleClose}
            path="/aboutUs"
            advancedMenuLogo={<IconAboutUs fillColor="#000" />}
          />
          <AdvancedMenuItems
            advancedMenuTitle="قوانین و مقررات"
            handleClose={handleClose}
            path="/siteRoles"
            advancedMenuLogo={<IconPolicy fillColor="#000" />}
          />
          <AdvancedMenuItems
            advancedMenuTitle="اطلاعات حرکت شناورها از بندر چارک"
            handleClose={handleClose}
            path="/s/kishportinfo"
            advancedMenuLogo={<Iconboat fillColor="#000" />}
          />
          <AdvancedMenuItems
            advancedMenuTitle="آب و هوای کیش"
            handleClose={handleClose}
            path="/weather"
            advancedMenuLogo={<IconWeather fillColor="#000" />}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AdvancedMenu;
